module.exports = __webpack_public_path__ + "static/media/integration-build.a55c7709.jpg";